import { apiClient, ApiError } from "@/api/client";
import { env } from "@/lib/env";
import type { TenantResolveResponse } from "@/types/auth";

interface TenantResolveRawResponse {
  tenantId: string;
  userPoolId: string;
  clientId: string;
  tenantName: string;
  tenantType?: string;
  branding?: {
    logoUrl?: string | null;
    primaryColor?: string | null;
    secondaryColor?: string | null;
  };
}

export async function resolveTenant(
  slug: string,
): Promise<TenantResolveResponse> {
  const raw = await apiClient<TenantResolveRawResponse>(
    `/tenants/resolve?slug=${encodeURIComponent(slug)}`,
    { authenticated: false, method: "GET" },
  );

  return {
    tenantId: raw.tenantId,
    tenantName: raw.tenantName,
    tenantType: (raw.tenantType as "hcp" | "clinical") ?? "hcp",
    cognitoConfig: {
      userPoolId: raw.userPoolId,
      clientId: raw.clientId,
      region: env.cognitoRegion,
      mfaRequired: false,
    },
    branding: {
      logoUrl: raw.branding?.logoUrl ?? null,
      primaryColor: raw.branding?.primaryColor ?? null,
      secondaryColor: raw.branding?.secondaryColor ?? null,
    },
  };
}

export function isTenantNotFound(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
